export const SN_ROOT = 'root'
export const USER_TOKEN_INVALIDATE_LOCK_CHANGED = SN_ROOT + '/USER_TOKEN_INVALIDATE_LOCK_CHANGED'
